import React, { Component } from 'react';
import { InputProps, State } from '../../shared/Types';
import './SearchBar.scss';

export default class SearchBar extends Component<InputProps, State> {
  constructor(props: InputProps) {
    super(props);

    this.state = {
      inputValue: '',
    };
  }

  handleInputValue = (event: React.ChangeEvent<HTMLInputElement>): void => {
    this.setState({ inputValue: event.target.value });
  };

  componentDidMount() {
    this.setState({
      inputValue: localStorage.getItem('inputValue') || '',
    });
  }

  componentDidUpdate() {
    localStorage.setItem('inputValue', this.state.inputValue);
  }

  componentWillUnmount() {
    localStorage.setItem('inputValue', this.state.inputValue);
  }

  render() {
    return (
      <div className="search-bar">
        <input
          data-testid="searchbar-input"
          type="text"
          placeholder="Write your text here"
          className="search-bar__input"
          onChange={this.handleInputValue}
          value={this.state.inputValue}
          role={'input'}
        />
        <button type="submit" className="search-bar__btn">
          Search
        </button>
      </div>
    );
  }
}
